import { Switch } from '@fluentui/react-components'
import React, { useCallback, useState } from 'react'
import './AppTypesAssignmentComponent.scss'
import { AppTypesArray } from '@/util/appTypes'
import { RestSchemas } from '@/contexts/QueryProvider'

type MessagesProjectsMemberRolesAssignment = RestSchemas['Messages.Projects.MemberRolesAssignment']

type AppTypesAssignmentComponentProps = {
  appTypes?: MessagesProjectsMemberRolesAssignment[]
  assignedAppTypesIds: number[] // Parent-provided initial assigned roles
  onAppTypesChange: (assignedRoles: number[]) => void
}

export const AppTypesAssignmentComponent: React.FC<AppTypesAssignmentComponentProps> = ({
  appTypes,
  assignedAppTypesIds: initialAssignedAppTypesIds,
  onAppTypesChange,
}) => {
  const [assignedAppTypesIds, setAssignedAppTypesIds] = useState<number[]>(() => initialAssignedAppTypesIds)

  const toggleRole = useCallback(
    (roleId: number, checked: boolean) => {
      const newAppTypesIds = checked
        ? [...assignedAppTypesIds, roleId]
        : assignedAppTypesIds.filter((id) => id !== roleId)
      setAssignedAppTypesIds(newAppTypesIds)
      onAppTypesChange(newAppTypesIds)
    },
    [onAppTypesChange, assignedAppTypesIds]
  )

  return (
    <div className="app-types-component">
      <span className="heading">Assign App Types</span>
      <div className="switch-container">
        {(appTypes ?? AppTypesArray)
          .filter((x) => x.roleId !== 0)
          .map((role) => {
            const isChecked = assignedAppTypesIds.includes(role.roleId)

            return (
              <Switch
                key={role.roleId}
                label={role.roleName}
                checked={isChecked}
                onChange={(_, data) => toggleRole(role.roleId, data.checked)}
                className={isChecked ? 'switch-checked' : ''}
                style={{ width: 'fit-content' }}
              />
            )
          })}
      </div>
    </div>
  )
}
